// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"a737c3a8","228":"13a6de42","569":"1306b3a7","936":"a1998a3b"}[chunkId] + ".chunk.css";
};